export const enum ShapeType {
  Pen = "pen",
  Line = "line",
  Rect = "rect",
  Ellipse = "ellipse",
  Diamond = "diamond",
  Text = "text",
  Eraser = "eraser",
  Node = "node",
}
